export default "__VITE_ASSET__BUnqDJzv__"